/**************************************************
 * Nombre:       Casilla_Falso_Verdadero
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {TableCell} from "@mui/material";
import {COLORTEXTO} from "../../../Constantes";

const Casilla_Falso_Verdadero = ({dato, dir}) => {

    return (
        <TableCell key={dato} variant={'body'} align={dir} sx={{color: COLORTEXTO, fontSize: 14, fontWeight: 500}}>
            {dato ? 'SI' : 'No'}
        </TableCell>

    )

}
export default Casilla_Falso_Verdadero